import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import { exportJsonToCSV } from '../../../../../../Utils/CSV';
import ImportParticipantsStore from '../../../Store';
import { FailedParticipant, SuccessfulParticipant, ViewReportAction } from '../../../Store/Types';

interface Props {
  store: ImportParticipantsStore;
  downloadData: Array<SuccessfulParticipant | FailedParticipant>;
  view: ViewReportAction;
}

function ViewAndDownloadCSV({ store, downloadData, view }: Props) {
  return (
    <p className="flex items-center justify-center text-sm mt-2 font-semibold">
      (
      <a onClick={() => store.viewReport(view)} className="cursor-pointer text-teal-600 ">
        <T kind="View all details" />
      </a>
      ) (
      <a
        href="#"
        onClick={() => exportJsonToCSV(downloadData, 'import_participants.csv')}
        className="cursor-pointer text-teal-600"
      >
        <T kind="Download full CSV" />
      </a>
      )
    </p>
  );
}

export default observer(ViewAndDownloadCSV);
